import type { IStyle } from 'fela';

import type { Theme } from '../types';

export const header: IStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  marginBottom: '24px'
};

export const icon: (theme?: Theme) => IStyle = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '76px',
  height: '76px',
  borderRadius: '50%',
  fontSize: '32px',
  backgroundColor: theme?.button?.style?.backgroundColor ?? '#cfff92',
  color: theme?.button?.style?.color ?? 'inherit'
});

export const body: IStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  minWidth: 0
};

export const title: (theme?: Theme) => IStyle = (theme) => ({
  margin: 0,
  fontWeight: 'bold',
  fontFamily: theme?.header?.font?.family ?? 'inherit'
});

export const description: IStyle = {
  margin: 0,
  opacity: 0.7
};
